const { default: axiosIns } = require('@/libs/axios')

const UserNotificationService = {
  // GET - UserNotificationApiController
  async getAll(accountId) {
    return axiosIns.get(`/usernotification/all/${accountId}`)
      .then(response => response.data)
  },
  async get(id) {
    return axiosIns.get(`/usernotification/${id}`)
      .then(response => response.data)
  },
  // POST - UserNotificationApiController
  async insert(model) {
    return axiosIns.post('/usernotification', model)
      .then(response => response.data)
  },
  // Delete - UserNotificationApiController
  async delete(id) {
    return axiosIns.delete(`/usernotification/${id}`)
      .then(response => response.data)
  },
  async getNotificationTypes() {
    return axiosIns.get('/usernotification/types').then(response => response.data)
  },
}
export default UserNotificationService
